import Model from 'flarum/common/Model';
export default class Ranking extends Model {
  catch_count = Model.attribute('catch_count');
  user = Model.hasOne('user');
}
flarum.reg.add('clarkwinkelmann-catch-the-fish', 'common/models/Ranking', Ranking);